import React from "react";
import { NavLink } from "react-router-dom";
import { useWeb3 } from "../../context/Web3Context";

const BASE_ITEMS = [
  { to: "/home", label: "Home", icon: "◆" },
  { to: "/packages", label: "Packages", icon: "▤" },
  { to: "/matrix", label: "Matrix", icon: "⬡" },
  { to: "/club", label: "Club", icon: "◎" },
];

const ADMIN_ITEM = { to: "/admin", label: "Contract", icon: "⚙" };

function BottomNav() {
  const { hasAdminAccess } = useWeb3();
  const items = hasAdminAccess ? [...BASE_ITEMS, ADMIN_ITEM] : BASE_ITEMS;
  return (
    <nav
      className="bottom-nav"
      style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}
      aria-label="Main navigation"
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => "bottom-nav-item" + (isActive ? " active" : "")}
          style={{ textDecoration: "none" }}
        >
          <span className="bottom-nav-icon">{item.icon}</span>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export default BottomNav;
